<div class="root">
    <div class="budget-item " (click)="onCardClick()" [ngClass]="{'income': item.amount>=0, 'expense': item.amount<0}">
        <div class="description">
            <p>{{ item.description}}</p>
        </div>
        <div class="amount">
            <p>{{ item.amount }}</p>
        </div>
    </div>
    <div class="x-icon-button" (click)="onXbuttonCick()"></div>
</div>